import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, deleteApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, ExcluirStatusRequest } from './types';

// ACTIONS
import { excluirStatusSuccess, excluirStatusFailure } from './actions';

function* excluirStatus(request: ReducerActionRotaSP) {
	const { token, payload }: { token?: string; payload: ExcluirStatusRequest } =
		request;

	const response: ApiResponse = yield call(
		deleteApi,
		token || '',
		PATH_SGU_API,
		`status/${payload.id}`,
	);

	if (response.status === 200) {
		yield put(excluirStatusSuccess(response));
	} else {
		yield put(excluirStatusFailure());
	}
}

export default all([takeLatest(Types.EXCLUIR_STATUS, excluirStatus)]);
